import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import {
  googleLoginAsync,
  loginUserAsync,
  logout,
  registerAsync,
  resetPasswordAsync,
  updatePasswordAsync,
} from "./actions";
import { AuthState } from "./slice";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "src/constants/cookiesKeys";
import { history } from "src/services/history";
import { PATHNAMES } from "src/constants/routes";

type Reducer = (builder: ActionReducerMapBuilder<AuthState>) => void;

export const loginUserReducer: Reducer = (builder) => {
  builder.addCase(loginUserAsync.fulfilled, (state) => {
    state.isLoading = false;
  });

  builder.addCase(loginUserAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(loginUserAsync.rejected, (state) => {
    state.isLoading = false;
  });
};

export const googleLoginReducer: Reducer = (builder) => {
  builder.addCase(googleLoginAsync.fulfilled, (state) => {
    state.isLoading = false;
  });

  builder.addCase(googleLoginAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(googleLoginAsync.rejected, (state) => {
    state.isLoading = false;
  });
};

export const registerReducer: Reducer = (builder) => {
  builder.addCase(registerAsync.fulfilled, (state) => {
    state.isLoading = false;
  });

  builder.addCase(registerAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(registerAsync.rejected, (state) => {
    state.isLoading = false;
  });
};

export const resetPasswordReducer: Reducer = (builder) => {
  builder.addCase(resetPasswordAsync.fulfilled, (state) => {
    state.isLoading = false;
  });

  builder.addCase(resetPasswordAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(resetPasswordAsync.rejected, (state) => {
    state.isLoading = false;
  });
};

export const updatePasswordReducer: Reducer = (builder) => {
  builder.addCase(updatePasswordAsync.fulfilled, (state) => {
    state.isLoading = false;
  });

  builder.addCase(updatePasswordAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(updatePasswordAsync.rejected, (state) => {
    state.isLoading = false;
  });
};

export const logoutReducer: Reducer = (builder) => {
  builder.addCase(logout, (state) => {
    Cookies.remove(ACCESS_TOKEN);
    Cookies.remove(REFRESH_TOKEN);
    history.replace(PATHNAMES.HOME);
  });
};
